module.exports = __webpack_public_path__ + "static/media/infoiscorrect.226932fb.mp3";